import BehaviorError from '../../behaviors/src/lib/error/behaviorError';
export const getBehaviorErrorMessage = error => {
  if (typeof (error === null || error === void 0 ? void 0 : error.message) === 'string' && error.message.trim().length > 0) {
    return error.message.trim();
  }
  if (typeof (error === null || error === void 0 ? void 0 : error.debugMessage) === 'string' && error.debugMessage.trim().length > 0) {
    return error.debugMessage.trim();
  }
  return 'Unknown behavior error';
};
export const getBehaviorErrorCause = (error, message) => {
  if (error instanceof Error) {
    return error;
  }
  if (typeof (error === null || error === void 0 ? void 0 : error.stack) === 'string' && error.stack.length > 0) {
    return Object.assign(new Error(message), {
      stack: error.stack
    });
  }
  return undefined;
};
export const toBehaviorError = (error, messagePrefix) => {
  var _error$statusCode;
  if (error instanceof BehaviorError) {
    return error;
  }
  const message = getBehaviorErrorMessage(error);
  const debugMessage = messagePrefix ? `${messagePrefix}: ${message}` : message;
  const statusCode = (_error$statusCode = error === null || error === void 0 ? void 0 : error.statusCode) !== null && _error$statusCode !== void 0 ? _error$statusCode : 500;
  return new BehaviorError(debugMessage, statusCode, undefined, getBehaviorErrorCause(error, message));
};